import i18n from "@translations/i18n";

export const getWelcomePhrase = (currentHours: number = 0) => {
  if (currentHours >= 5 && currentHours < 12)
    return i18n.t("dashboardPage.header.welcomePhrases.morning");
  if (currentHours >= 12 && currentHours < 17)
    return i18n.t("dashboardPage.header.welcomePhrases.afternoon");
  return i18n.t("dashboardPage.header.welcomePhrases.evening");
};
